export const PAGE_SIZE = 50;

export const MATCH_SCOPES = [
  { value: 'all', label: 'All' },
  { value: 'pvp', label: 'PvP' },
  { value: 'pvai', label: 'PvAI' },
  { value: 'league', label: 'League' },
];

export const LEAGUE_EVENT_TYPES = [
  'super_over_league_viewed',
  'super_over_league_stats_viewed',
  'super_over_league_match_started',
  'super_over_league_match_won',
  'super_over_league_match_lost',
  'super_over_league_match_completed',
  'super_over_league_cycle_completed',
  'super_over_league_promoted',
  'super_over_league_stayed',
  'super_over_league_demoted',
  'super_over_league_trophy_won',
  'super_over_league_reward_claimed',
];

export const CYCLE_OUTCOMES = ['demotion', 'stay', 'promotion', 'trophy'];

/** Local calendar YYYY-MM-DD */
export const getLocalDateString = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const addDaysToDateString = (dateStr, days) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + days);
  return getLocalDateString(dt);
};

export const formatDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString();
};

export const formatNullable = (value) =>
  value === null || value === undefined || value === '' ? '—' : String(value);

export const emptyEconomy = () => ({
  match_entry_fe: 0,
  match_win_fe: 0,
  match_tie_fe: 0,
  match_lose_fe: 0,
});

export const emptyLevel = (level) => ({
  level,
  games_required: 10,
  band_name: `Level ${level}`,
  demotion_max: level === 1 ? null : 0,
  stay_min: 0,
  stay_max: 3,
  promotion_min: level === 15 ? null : 4,
  trophy_min: 5,
  stay_fe: 0,
  promotion_fe: level === 15 ? null : 0,
  trophy_fe: 0,
});

export const cloneLevels = (levels) =>
  (Array.isArray(levels) ? levels : []).map((row) => ({ ...row }));

export const toIntOrNull = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? Math.trunc(n) : null;
};

export const toNonNegInt = (value, fallback = 0) => {
  const n = toIntOrNull(value);
  if (n === null || n < 0) return fallback;
  return n;
};

/** Client-side sanity check before PUT levels (server is source of truth). */
export const validateLevelsClient = (levels) => {
  if (!Array.isArray(levels) || levels.length !== 15) {
    return 'Exactly 15 levels (1–15) are required.';
  }
  const seen = new Set();
  for (const row of levels) {
    const lvl = Number(row.level);
    if (!Number.isInteger(lvl) || lvl < 1 || lvl > 15 || seen.has(lvl)) {
      return 'Each level 1–15 must appear exactly once.';
    }
    seen.add(lvl);
    if (lvl === 1 && row.demotion_max != null) {
      return 'Level 1 demotion_max must be null.';
    }
    if (lvl === 15) {
      if (row.promotion_min != null) return 'Level 15 promotion_min must be null.';
      if (row.promotion_fe != null) return 'Level 15 promotion_fe must be null.';
    }
  }
  return '';
};
